import { localDate } from '@/platform/lib/utils';
import {
    Badge,
    Button,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';
import dayjs from 'dayjs';
import { useState } from 'react';
import SroiEntitlementCard from './components/SroiEntitlementCard';
import SroiEntitlementPanel from './components/SroiEntitlementPanel';
import EmployeeShowLayout from './layouts/EmployeeShowLayout';

const isActive = entitlement =>
    !dayjs(entitlement.start_date).isAfter(dayjs(), 'day') &&
    (!entitlement.end_date ||
        !dayjs(entitlement.end_date).isBefore(dayjs(), 'day'));

const SroiView = () => {
    const { auth, employee } = usePage().props;

    const [editing, setEditing] = useState(null);

    const entitlements = [...(employee?.sroi_entitlements ?? [])].sort((a, b) =>
        dayjs(b.start_date).diff(dayjs(a.start_date))
    );
    const active = entitlements.find(isActive);

    return (
        <>
            <Segment>
                <SegmentHeader
                    header={
                        <span className='inline-flex items-center gap-2'>
                            SROI
                            {active ? (
                                <Badge color='green'>Actief</Badge>
                            ) : (
                                <Badge color='gray'>Niet actief</Badge>
                            )}
                        </span>
                    }
                    subheader={
                        active
                            ? `${active.pso_category_label} · sinds ${localDate(active.start_date)}${active.end_date ? ` tot ${localDate(active.end_date)}` : ', doorlopend'}`
                            : 'Deze werknemer telt op dit moment niet mee voor SROI.'
                    }
                >
                    {auth?.permissions?.includes('create sroi') && (
                        <Button
                            type='button'
                            variant='primary'
                            onClick={() => setEditing(false)}
                        >
                            <PlusIcon className='size-4' />
                            Toevoegen
                        </Button>
                    )}
                </SegmentHeader>
                {entitlements.length === 0 && (
                    <SegmentContent>
                        <p className='text-sm text-gray-500'>
                            Deze werknemer heeft nog geen SROI-rechten. Voeg er
                            een toe als de werknemer tot een PSO-doelgroep
                            behoort.
                        </p>
                    </SegmentContent>
                )}
            </Segment>

            {entitlements.map(entitlement => (
                <SroiEntitlementCard
                    entitlement={entitlement}
                    onEdit={setEditing}
                    key={entitlement.id}
                />
            ))}

            {editing !== null && (
                <SroiEntitlementPanel
                    entitlement={editing || null}
                    onClose={() => setEditing(null)}
                />
            )}
        </>
    );
};

SroiView.layout = page => <EmployeeShowLayout>{page}</EmployeeShowLayout>;

export default SroiView;
